module.exports = __webpack_public_path__ + "static/media/glowing-container.5d1b6d82.png";